import { jsx } from "react/jsx-runtime";
import { Provider } from "react-redux";
import { store, StoreContext } from "../../internal/app/store.js";
function TradeInProvider({ children }) {
  return /* @__PURE__ */ jsx(Provider, { store, context: StoreContext, children });
}
export {
  TradeInProvider
};
